import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["g-btn", [_ctx.type]]),
    style: _normalizeStyle({ width: _ctx.width, height: _ctx.height, 'font-size': _ctx.fontSize })
  }, _toDisplayString(_ctx.text), 7))
}